/**
 * Simple aspect that is used to suggest the type of input directive that
 * should be used based on the metadata for the property
 */
define([], ()=> {
    function getInputCtrlType(metadataType) {
        let inputType = 'text';
        const isClass = metadataType.kind !== 'primitive';
        if (isClass && metadataType.typeInfo.metaType.isTypelist) {
            inputType = 'typelist';
        } else if (metadataType.name === 'Date') {
            inputType = 'date';
        } else if (metadataType.name === 'Integer') {
            inputType = 'tel'; // We use tel for integer as the input type for number is also applicable for floats.
        } else if (metadataType.name === 'Boolean') {
            inputType = 'boolean';
        }
        return inputType;
    }

    return {
        'getAspectProperties': (currentViewModelNode, currentMetadataNode/*, ancestorChain*/)=> {
            return {
                'inputCtrlType': {
                    'get': ()=> {
                        return getInputCtrlType(currentMetadataNode.valueType);
                    }
                }
            };
        }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/viewmodel/aspects/InputCtrlType.js
 **/